import { render, staticRenderFns } from "./GroupWraper.vue?vue&type=template&id=4c84da30&scoped=true"
import script from "./GroupWraper.vue?vue&type=script&lang=js"
export * from "./GroupWraper.vue?vue&type=script&lang=js"
import style0 from "./GroupWraper.vue?vue&type=style&index=0&id=4c84da30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c84da30",
  null
  
)

export default component.exports